/**
 * Created by rickborst on 13/06/2017.
 */

import {getInstance as getDataSources} from 'datasources';

const ActionTypes = {
        SET_TOP_NAVIGATION: 'SET_TOP_NAVIGATION',
        SET_PREVIOUS_LOCATION: 'SET_PREVIOUS_LOCATION',
        SET_TOP_DISTANCE: 'SET_TOP_DISTANCE',
        SET_FROM_BACK: 'SET_FROM_BACK',
        SET_COLLECTION_PAGES_AMOUNT: 'SET_COLLECTION_PAGES_AMOUNT'
    },

    /**
     * Sets the top navigation state.
     *
     * @param {Object} items - Navigation items.
     * @returns {Object} Action.
     */
    setTopNavigation = function (items) {

        return {
            type: ActionTypes.SET_TOP_NAVIGATION,
            items: items
        };
    },


    /**
     * Gets the top navigation items.
     *
     * @returns {Function} Function.
     */
    getTopNavigation = function () {
        let dataSources = getDataSources();

        return dispatch => {

            dataSources.getTopNavigation()
                .then(items => {
                    dispatch(setTopNavigation(items));
                });
        };
    };

    /**
     * Creates and returns a set top distance action.
     *
     * @param {Asset} toTopDistance - Distance to top.
     * @returns {Object} Set distance to top.
     */
    function setTopDistance (toTopDistance) {
        return {
            type: ActionTypes.SET_TOP_DISTANCE,
            toTopDistance
        };
    }

    /**
     * Creates and returns a set from back action.
     *
     * @param {Asset} isFromBack - Is from back.
     * @returns {Object} Set is from back value.
     */
    function setFromBack (isFromBack) {
        return {
            type: ActionTypes.SET_FROM_BACK,
            isFromBack
        };
    }

    /**
     * Creates and returns a set collectionPagesAmount action.
     *
     * @param {Asset} collectionPagesAmount - Collection pages amount.
     * @returns {number} Set collection pages amount.
     */
    function setCollectionPagesAmount (collectionPagesAmount) {
        return {
            type: ActionTypes.SET_COLLECTION_PAGES_AMOUNT,
            collectionPagesAmount
        };
    }

export {
    ActionTypes,
    getTopNavigation,
    setTopDistance,
    setFromBack,
    setCollectionPagesAmount
};


// WEBPACK FOOTER //
// ./src/js/store/actions/widgets/navigation.js